export const prescriptions = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'ink',
  color: 'inkText',
  NavSidebar: {},
  TabInit: {
    display: 'none',
    show: (() => {
      let d = false
      return (el, s) => {
        if (!d) {
          d = true
          Promise.resolve().then(() =>
            s.root.update({ activeTab: 'prescriptions' })
          )
        }
        return false
      }
    })()
  },

  MainContent: {
    flow: 'y',
    flex: '1',
    overflow: 'auto',
    TopBar: {},
    ContentArea: {
      flow: 'y',
      gap: 'B',
      padding: 'B',
      flex: '1',

      RxNav: {
        flow: 'x',
        gap: 'Z',
        borderBottom: '1px solid inkBorder',
        paddingBottom: 'Y',
        TabActive: {
          text: '{{ activeRx | polyglot }}',
          fontSize: 'Z',
          fontWeight: '600',
          padding: 'Y Z',
          cursor: 'pointer',
          color: (el, s) =>
            s.root.activeRxTab === 'active' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) =>
            s.root.activeRxTab === 'active'
              ? '2px solid teal'
              : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ activeRxTab: 'active' })
        },
        TabPast: {
          text: '{{ pastRx | polyglot }}',
          fontSize: 'Z',
          fontWeight: '600',
          padding: 'Y Z',
          cursor: 'pointer',
          color: (el, s) =>
            s.root.activeRxTab === 'past' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) =>
            s.root.activeRxTab === 'past'
              ? '2px solid teal'
              : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ activeRxTab: 'past' })
        },
        TabTemplates: {
          text: '{{ templates | polyglot }}',
          fontSize: 'Z',
          fontWeight: '600',
          padding: 'Y Z',
          cursor: 'pointer',
          color: (el, s) =>
            s.root.activeRxTab === 'templates' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) =>
            s.root.activeRxTab === 'templates'
              ? '2px solid teal'
              : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ activeRxTab: 'templates' })
        },
        TabInteractions: {
          text: '{{ interactionCheck | polyglot }}',
          fontSize: 'Z',
          fontWeight: '600',
          padding: 'Y Z',
          cursor: 'pointer',
          color: (el, s) =>
            s.root.activeRxTab === 'interactions' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) =>
            s.root.activeRxTab === 'interactions'
              ? '2px solid teal'
              : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ activeRxTab: 'interactions' })
        }
      },

      // Active Prescriptions
      ActiveRxView: {
        flow: 'y',
        gap: 'A',
        show: (el, s) => s.root.activeRxTab === 'active',
        ActiveTitle: {
          text: '{{ activePrescriptions | polyglot }}',
          fontSize: 'A',
          fontWeight: '700',
          color: 'inkText'
        },
        ActiveList: {
          flow: 'x wrap',
          gap: 'Z',
          children: [
            {
              drugName: 'Amoxicillin',
              dosage: '500mg',
              frequency: 'TID (3x daily)',
              duration: '7 days',
              prescribedBy: 'Dr. Lomidze',
              prescribedDate: 'Mar 16, 2026',
              patientName: 'Giorgi Beridze',
              refillsRemaining: 0,
              indication: 'Post-extraction prophylaxis',
              pharmacy: 'GPC Pharmacy, Rustaveli Ave',
              status: 'Active'
            },
            {
              drugName: 'Ibuprofen',
              dosage: '400mg',
              frequency: 'PRN (as needed)',
              duration: '5 days',
              prescribedBy: 'Dr. Lomidze',
              prescribedDate: 'Mar 16, 2026',
              patientName: 'Giorgi Beridze',
              refillsRemaining: 1,
              indication: 'Post-operative pain management',
              pharmacy: 'GPC Pharmacy, Rustaveli Ave',
              status: 'Active'
            },
            {
              drugName: 'Chlorhexidine Gluconate',
              dosage: '0.12% rinse',
              frequency: 'BID (2x daily)',
              duration: '14 days',
              prescribedBy: 'Dr. Kvaratskhelia',
              prescribedDate: 'Mar 14, 2026',
              patientName: 'Nino Kapanadze',
              refillsRemaining: 0,
              indication: 'Periodontal therapy adjunct',
              pharmacy: 'Aversi Pharmacy, Chavchavadze',
              status: 'Active'
            }
          ],
          childrenAs: 'state',
          childExtends: 'PrescriptionCard'
        }
      },

      // Past Prescriptions
      PastRxView: {
        flow: 'y',
        gap: 'A',
        show: (el, s) => s.root.activeRxTab === 'past',
        PastTitle: {
          text: '{{ pastPrescriptions | polyglot }}',
          fontSize: 'A',
          fontWeight: '700',
          color: 'inkText'
        },
        PastList: {
          flow: 'y',
          gap: 'Z',
          opacity: '0.5',
          children: [
            {
              drugName: 'Amoxicillin',
              dosage: '500mg',
              frequency: 'TID',
              duration: '10 days',
              prescribedBy: 'Dr. Lomidze',
              prescribedDate: 'Feb 10, 2026',
              patientName: 'Davit Gelashvili',
              refillsRemaining: 0,
              indication: 'Dental abscess',
              pharmacy: 'GPC Pharmacy',
              status: 'Expired'
            },
            {
              drugName: 'Metronidazole',
              dosage: '400mg',
              frequency: 'TID',
              duration: '7 days',
              prescribedBy: 'Dr. Beridze',
              prescribedDate: 'Feb 5, 2026',
              patientName: 'Mariam Tsiklauri',
              refillsRemaining: 0,
              indication: 'Anaerobic infection',
              pharmacy: 'Aversi Pharmacy',
              status: 'Expired'
            },
            {
              drugName: 'Clindamycin',
              dosage: '300mg',
              frequency: 'QID',
              duration: '7 days',
              prescribedBy: 'Dr. Lomidze',
              prescribedDate: 'Jan 22, 2026',
              patientName: 'Ana Javakhishvili',
              refillsRemaining: 0,
              indication: 'Penicillin allergy alternative',
              pharmacy: 'PSP Pharmacy',
              status: 'Expired'
            },
            {
              drugName: 'Acetaminophen',
              dosage: '500mg',
              frequency: 'Q6H PRN',
              duration: '3 days',
              prescribedBy: 'Dr. Kvaratskhelia',
              prescribedDate: 'Jan 18, 2026',
              patientName: 'Luka Mchedlishvili',
              refillsRemaining: 0,
              indication: 'Post-extraction pain',
              pharmacy: 'GPC Pharmacy',
              status: 'Expired'
            },
            {
              drugName: 'Fluconazole',
              dosage: '100mg',
              frequency: 'QD',
              duration: '14 days',
              prescribedBy: 'Dr. Beridze',
              prescribedDate: 'Jan 10, 2026',
              patientName: 'Tamara Lomidze',
              refillsRemaining: 0,
              indication: 'Oral candidiasis',
              pharmacy: 'Aversi Pharmacy',
              status: 'Expired'
            },
            {
              drugName: 'Dexamethasone',
              dosage: '4mg',
              frequency: 'BID',
              duration: '3 days',
              prescribedBy: 'Dr. Lomidze',
              prescribedDate: 'Dec 20, 2025',
              patientName: 'Irakli Diasamidze',
              refillsRemaining: 0,
              indication: 'Post-surgical swelling',
              pharmacy: 'PSP Pharmacy',
              status: 'Expired'
            }
          ],
          childrenAs: 'state',
          childExtends: 'PrescriptionCard'
        }
      },

      // Templates View
      TemplatesView: {
        flow: 'y',
        gap: 'A',
        show: (el, s) => s.root.activeRxTab === 'templates',
        TemplatesTitle: {
          text: '{{ prescriptionTemplates | polyglot }}',
          fontSize: 'A',
          fontWeight: '700',
          color: 'inkText'
        },
        RxTemplateSelector: {}
      },

      // Interaction Check View
      InteractionCheckView: {
        flow: 'y',
        gap: 'A',
        show: (el, s) => s.root.activeRxTab === 'interactions',
        InteractionsTitle: {
          text: '{{ drugInteractionChecker | polyglot }}',
          fontSize: 'A',
          fontWeight: '700',
          color: 'inkText'
        },
        InteractionAlerts: {
          flow: 'y',
          gap: 'Z',
          Alert1: {
            extends: 'DrugInteractionAlert',
            state: {
              drugA: 'Amoxicillin',
              drugB: 'Warfarin',
              severity: 'Major',
              description:
                'Amoxicillin may increase the anticoagulant effect of Warfarin. Monitor INR closely and adjust Warfarin dose if necessary. Risk of bleeding may be elevated during concurrent use.',
              recommendation:
                'Monitor INR within 3-5 days of starting Amoxicillin. Consider dose reduction of Warfarin if INR rises above therapeutic range.'
            }
          },
          Alert2: {
            extends: 'DrugInteractionAlert',
            state: {
              drugA: 'Ibuprofen',
              drugB: 'Aspirin',
              severity: 'Moderate',
              description:
                'Ibuprofen may reduce the cardioprotective antiplatelet effect of low-dose Aspirin. NSAIDs compete for COX-1 binding site when taken concurrently.',
              recommendation:
                'Administer Aspirin at least 30 minutes before or 8 hours after Ibuprofen. Consider alternative analgesic such as Acetaminophen.'
            }
          }
        }
      }
    },
    MobileTabBar: {}
  }
}
